import React from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import BEMHelper from '@ynap/bem-helper';
import { QuickAddButton as QuickAddButtonComponent } from '@ynap/button';
import { withAnalytics, safeBuildEventObj } from '@ynap/analytics';
import { withOptimizely } from '@ynap/optimizely-utils';
import { raygun } from '@ynap/clientside-monitoring';
import ProductSummary from '../ProductSummary/ProductSummary';
import { trackAddToBagNonBasketProduct } from '@ynap/product-details-page';

const bem = new BEMHelper('ProductSummaryWithQuickAdd');

const ProductSummaryWithQuickAdd = (props) => {
    const {
        messages,
        product,
        openProductDetail,
        loading: isFetching,
        addToCart,
        locale,
        children,
        productImageAspectRatio,
        tracking,
        analytics,
        hasDotAlert,
        className,
        classNameButton,
        optimizely,
        hidePrice = false,
        isLastAdded,
        inProgress,
        addMicrodata,
    } = props;

    const trackedAddToBag = (partNumber, product) => {
        optimizely?.track('recommendation_addToCart');

        return addToCart(partNumber, 1)
            ?.then((response) => {
                if (response && response.type === 'ADD_TO_CART_SUCCESS') {
                    return tracking.trackEvent(safeBuildEventObj(trackAddToBagNonBasketProduct, analytics, product, partNumber, 'recommendation'));
                }
            })
            .catch((error) => {
                raygun.helpers.agent('send', {
                    error: new Error(`Recommendations Add To Cart error`),
                    tags: [`addToCartError`, `recommendations`],
                    customData: { ...error, partNumber },
                });
            });
    };

    const productToRender = isFetching ? {} : product;
    const onClick = product.displayable ? openProductDetail : null;

    const QuickAddButton = () =>
        !isFetching && product.displayable ? (
            <QuickAddButtonComponent
                className={bem('addToBagBtn', undefined, classNameButton)}
                product={product}
                addToCart={trackedAddToBag}
                onMobileQuickAddClick={onClick}
                isLastAdded={isLastAdded}
                inProgress={inProgress}
            />
        ) : null;

    return (
        <div className={bem()}>
            <ProductSummary
                product={productToRender}
                messages={messages}
                loading={isFetching}
                className={bem('productSummary', undefined, className)}
                productImageAspectRatio={productImageAspectRatio}
                locale={locale}
                hasDotAlert={hasDotAlert}
                hidePrice={hidePrice}
                QuickAddButton={QuickAddButton}
                optimizely={optimizely}
                addMicrodata={addMicrodata}
            >
                {children}
            </ProductSummary>
        </div>
    );
};

ProductSummaryWithQuickAdd.propTypes = {
    messages: PropTypes.shape({
        ctaButtons: PropTypes.shape({
            add: PropTypes.func.isRequired,
            goToBag: PropTypes.func.isRequired,
        }),
    }),
    locale: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
    openProductDetail: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    addToCart: PropTypes.func.isRequired,
    addToCartLoading: PropTypes.bool,
    addToCartError: PropTypes.string,
    children: PropTypes.node,
    productImageAspectRatio: PropTypes.string,
    tracking: PropTypes.shape({
        trackEvent: PropTypes.func,
    }),
    analytics: PropTypes.object,
    hasDotAlert: PropTypes.bool,
    className: PropTypes.string,
    classNameButton: PropTypes.string,
    optimizely: PropTypes.shape({
        track: PropTypes.func,
    }),
    hidePrice: PropTypes.bool,
    isLastAdded: PropTypes.bool,
    inProgress: PropTypes.bool,
    addMicrodata: PropTypes.bool,
};

export default track()(withAnalytics(withOptimizely(ProductSummaryWithQuickAdd)));
